// @flow
import * as React from 'react';
import styles from './styles';

export type Props = {
  url: string,
  withBorderRadius?: boolean,
  children: React.ChildrenArray<*>,
  color: 'primary' | 'flat' | 'blue' | 'orange',
  onClick: ?Function,
  target?: '_blank' | '_self' | '_parent' | '_top',
  dataTest?: ?string,
};

export default function LinkButton({
  url,
  children,
  color,
  withBorderRadius,
  target,
  onClick,
  dataTest,
}: Props): React.Node {
  return (
    <a
      href={url}
      className={`link-button ${color} ${withBorderRadius ? 'with-border-radius' : ''}`}
      target={target}
      rel="nofollow"
      onClick={onClick}
      data-test={dataTest}
    >
      {children}
      <style jsx>{styles}</style>
    </a>
  );
}

LinkButton.defaultProps = {
  target: '_blank',
  withBorderRadius: false,
  dataTest: null,
};



// WEBPACK FOOTER //
// ./app/common/Links/LinkButton/index.js